<template>
    <div>
        <h4>Details & Historie</h4>

        <div>
            <b-alert class="mb-2" variant="finished" show>
                <strong>
                    <i class="fas fa-check-circle mr-1 text-success"></i> {{lead.status.title}}
                </strong>
                <small>
                    <br />
                    {{statusDescription}}
                </small>
                <div>
                    <button @click="download" class="btn btn-light btn-sm mt-2">
                        <i class="fas fa-file-pdf"></i> Download als PDF bestand
                    </button>
                </div>
            </b-alert>

            <show-event v-if="lead.ep_nr" :event-data="data" :loaded="loaded"></show-event>
            <lead-data :lead="lead"></lead-data>
        </div>
    </div>
</template>

<script>
    import ShowEvent from './showEvent';
    import LeadData from "./leadData";
    import FileSaver from 'file-saver';

    export default {
        components: {
            LeadData,
            ShowEvent
        },
        props: {
            lead: {
                type: Object,
                required: false
            },
        },
        data() {
            return {
                q: null,
                loaded: new Date(),
                errors: [],
                data: null
            }
        },
        computed: {
            statusDescription() {
                let messages = [];
                if(this.lead) {
                    if(this.lead.finished_at) {
                        messages.push('Op ' + this.moment(this.lead.finished_at).format('L LT'));
                    }
                    if(this.lead.finished_by) {
                        messages.push('door ' + this.lead.finished_by.name);
                    }
                    if(this.lead.ep_nr) {
                        messages.push('reserveringsnummer ' + this.lead.ep_nr);
                    }
                }

                return messages.join(', ');
            },
            leads() {
                if(this.data) {
                    return this.data.leads;
                }
                return [];
            },
            event() {
                if(this.data) {
                    return this.data.event;
                }
                return null;
            }
        },
        watch: {
            lead() {
                this.load();
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                if(!this.lead || !this.lead.ep_nr) {
                    return;
                }
                this.loaded = null;
                this.errors = [];
                axios.get('/api/v1/leads/ep/' + this.lead.id + '/')
                    .then(response => {
                        this.loaded = new Date();
                        this.data = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            date(date) {
                let now = this.moment();
                let nowCheck = this.moment().startOf("day");
                let yest = this.moment().subtract(1, "day").startOf("day");
                let mom = this.moment(date).startOf("day");
                if(mom.isSame(now, 'day')) {
                    return 'Vandaag';
                } else if(mom.isSame(yest, 'day')) {
                    return 'Gisteren';
                }
                return mom.format('L');
            },
            download() {
                this.errors = [];
                axios({
                    url: '/api/v1/leads/form/' + this.lead.id + '/export/pdf', method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        FileSaver.saveAs(new Blob([response.data], {type: response.headers['content-type']}), 'Kopie_lead_' + this.lead.id + '.pdf');
                    })
                    .catch(error => {
                        this.errors = ['Something went wrong. Please try again.'];
                    });
            }
        }
    }

</script>

<style lang="scss">
</style>